// extracted by mini-css-extract-plugin
module.exports = {"blogContent":"blog_blogContent__Tf9Rv"};